import ICMS from '../Taxes/ICMS'
import IPI from "../Taxes/IPI"
import PIS from "../Taxes/PIS"
import COFINS from "../Taxes/COFINS"

export const paths = [
    {
        path: '/taxes/icms',
        component: ICMS
    },
    {
        path: '/taxes/ipi',
        component: IPI
    },
    {
        path: '/taxes/pis',
        component: PIS
    },
    {
        path: '/taxes/cofins',
        component: COFINS
    }
]
export const TaxesRouters = {
    icon: "balance-scale",
    path: "/taxes",
    testId: '',
    label: "Impostos",
    tree: [
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/icms',
            label: "ICMS"
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/ipi',
            label: "IPI"
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/pis',
            label: "PIS"
        },
        {
            testId: '',
            icon: 'balance-scale',
            path: '/taxes/cofins',
            label: "COFINS"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/routers.js